SupportContactChannelClickTemplate = require '../../../../contact_channel_click.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormCallClickView extends Backbone.View
  className: 'contact-channel-click-container'

  events :
    'click #returnHome' : "returnHome"

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @template = SupportContactChannelClickTemplate
    @contactChannelTextView = @options.contactChannelTextView
    @phoneNumberView = @options.phoneNumberView

  render: ->
    @$el.html toHtml(@template, @toHash(), @I18nScope)
    @phoneNumberView.render()
    @$el.find(".phone-number-container").html(@phoneNumberView.el)
    @contactChannelTextView.render()
    @contactChannelTextView.$el.removeClass()
    @$el.find(".contact-channel-container").html(@contactChannelTextView.el)

  toHash: ->
    hash =
      isCallClicked: true
    hash

  returnHome: () ->
    window.location.href = "/"

  postRenderhandler: () ->
    @contactChannelTextView.renderLiveChat()

module.exports = EmailFormCallClickView
